import React from "react";
import { Leaf, Sprout, Wheat, Flame, Sparkles, FlaskConical } from "lucide-react";

const items = [
  {
    name: "Ashwagandha",
    role: "Strength & Stamina",
    benefit: "Traditionally used to support strength, energy and stress resilience.",
    icon: Leaf,
    gradient: "from-[#FF7A00] via-[#FF5A00] to-[#8a2a00]",
  },
  {
    name: "Shatavari",
    role: "Vitality Support",
    benefit: "A classical Ayurvedic root revered for overall vitality and balance.",
    icon: Sprout,
    gradient: "from-[#FFC107] via-[#FF9420] to-[#7a3a00]",
  },
  {
    name: "Kaunch Beej",
    role: "Muscle Recovery",
    benefit: "Ayurvedic seed traditionally used for muscle nourishment and vigor.",
    icon: Wheat,
    gradient: "from-[#FF9420] via-[#FF6a00] to-[#6a1a00]",
  },
  {
    name: "Loh Bhasma",
    role: "Iron & Energy",
    benefit: "Ayurvedic mineral preparation to support iron levels and endurance.",
    icon: Flame,
    gradient: "from-[#FFB300] via-[#FF7A00] to-[#4a1a00]",
  },
  {
    name: "Gokhru",
    role: "Vigor & Drive",
    benefit: "Classical herb traditionally used for stamina and inner strength.",
    icon: Sparkles,
    gradient: "from-[#FF7A00] via-[#c14500] to-[#3a0a00]",
  },
  {
    name: "More Ayurvedic Herbs",
    role: "Traditional Blend",
    benefit: "A synergistic blend of time-tested Ayurvedic ingredients.",
    icon: FlaskConical,
    gradient: "from-[#FFC107] via-[#FF8500] to-[#5a1a00]",
  },
];

export default function Ingredients() {
  return (
    <section className="relative bg-black px-5 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 text-center sm:text-left">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FF7A00]">Ingredients</div>
          <h2 className="mt-2 font-display text-4xl text-white sm:text-5xl">
            Powerful Ayurvedic <br className="hidden sm:block" />
            <span className="text-fire">Herbs</span> Inside
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-neutral-400 sm:mx-0">
            Six traditional Ayurvedic ingredients, each chosen for a specific role in
            supporting healthy weight gain and daily strength.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3">
          {items.map(({ name, role, benefit, icon: Icon, gradient }) => (
            <div
              key={name}
              className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-neutral-950 p-5 transition-transform hover:-translate-y-0.5 sm:p-6"
            >
              {/* Decorative gradient thumbnail */}
              <div className={`relative mb-4 flex h-28 items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br ${gradient} sm:h-32`}>
                <div className="absolute inset-0 opacity-30 mix-blend-overlay grain" />
                <Icon size={44} className="relative z-10 text-white drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" strokeWidth={1.5} />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <div className="text-[10px] uppercase tracking-widest text-[#FFC107]">{role}</div>
              <div className="mt-1 font-display text-2xl leading-tight text-white">{name}</div>
              <p className="mt-2 text-sm leading-relaxed text-neutral-400">{benefit}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
